export default [
    [1, 'Homme'], // "Mr"
    [2, 'Femme'], // "Mrs"
    [9, 'Autre'], // Other
]
